export const sortAmount = (a, b) => {
  const parseValue = (value) => {
    if (!value && value !== 0) return 0;

    // If it's already a number, return it directly
    if (typeof value === "number") return value;

    // If it's not a string, convert to string first
    if (typeof value !== "string") return 0;

    const trimmedValue = value.trim();
    const isNegative = trimmedValue.startsWith("($") && trimmedValue.endsWith(")");
    const number = parseFloat(trimmedValue.replace(/[^\d.]/g, ""));
    return isNegative ? -number : number;
  };
  const numA = parseValue(a);
  const numB = parseValue(b);
  return numA - numB;
};

// Function to sort FSA (Farm Service Agency) numbers, which may include alphanumeric suffixes.
// This function handles cases where FSA numbers have variations like "123", "123A", "123-1", "123.1B", etc.
export const fsaSort = (a, b) => {
  // Split each FSA number into parts based on common separators (hyphen, space, period).
  const partsA = a.split(/[- .]/);
  const partsB = b.split(/[- .]/);

  // Iterate through the parts of both FSA numbers, comparing them part by part.
  for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
    // Get the current part for each FSA number, or an empty string if there are no more parts.
    const partA = partsA[i] || "";
    const partB = partsB[i] || "";

    // Parse each part to extract the numeric and suffix components.
    const parsedA = parseFsaPart(partA);
    const parsedB = parseFsaPart(partB);

    // Compare the numeric parts. If they are different, return the comparison result.
    if (parsedA.num !== parsedB.num) {
      return parsedA.num - parsedB.num;
    }

    // If the numeric parts are the same, compare the suffixes alphabetically.
    const suffixCompare = parsedA.suffix.localeCompare(parsedB.suffix);
    // If the suffixes are different, return the comparison result.
    if (suffixCompare !== 0) {
      return suffixCompare;
    }
    // if the numeric and suffix parts are same, continue the loop
  }

  // If all parts are equal, the FSA numbers are considered equal.
  return 0;
};

// Function to parse a single part of an FSA number and extract its numeric and suffix components.
const parseFsaPart = (part) => {
  // Extract all numeric digits from the part using a regular expression.
  const numMatch = part.match(/\d+/g) || []; // ['123'] or []

  // Remove all digits from the part to get the suffix (if any).
  const suffix = part.replace(/\d+/g, "") || ""; // "A" or ""

  // Return an object containing the numeric and suffix components.
  return {
    // If there were numeric digits, parse the first match as an integer.
    // Otherwise, use -Infinity to ensure that parts without numbers come first when sorting.
    num: numMatch.length > 0 ? parseInt(numMatch[0], 10) : -Infinity,
    // Convert the suffix to uppercase for case-insensitive comparison.
    suffix: suffix.toUpperCase(),
  };
};

export const formatText = (text) =>
  text
    ?.split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ") || "";

export const formatTextShort = (text) =>
  text?.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1))?.[1] || "";

export const formatUnitNumber = (basic_unit_number, optional_unit_number) =>
  [basic_unit_number, optional_unit_number].filter(Boolean).join("-") || "";
